
import { Mixins } from '@vedicium/metronic-vue';
import { ValidatorUtil } from '@vedicium/vue-core';
import Vue from 'vue';
import { Validation } from 'vuelidate';
import { LightSourcePartDto, LightSourcePartsStore } from '../../../../services/parts';

import { PartsLightSourcesInformationForm } from './components';

export default Vue.extend({
  name: 'partsLightSourcesCreate',
  mixins: [Mixins.KTWizardV4],
  components: {
    PartsLightSourcesInformationForm,
  },
  data() {
    return {
      isMounted: false,
      isLoadingForm: false,

      light_source: new LightSourcePartDto(),

      metadata: {
        wizard: {
          index: 0,
        },
      },
    };
  },

  beforeMount() {
    this.$metronic.breadcrumbs.setBreadcrumbs([
      { title: 'Parts', route: '/parts' },
      { title: 'Light sources', route: '/parts/light-sources' },
      { title: 'Create light source' },
    ]);
  },
  async mounted() {
    await this.$nextTick();

    this.$set(this, 'isMounted', true);
    (this.$refs.wizard as Vue).$on('step-change', this.onWizardStepChange.bind(this));
  },
  beforeDestroy() {
    (this.$refs.wizard as Vue).$off('step-change', this.onWizardStepChange.bind(this));
  },

  methods: {
    async submitForm() {
      this.$set(this, 'isLoadingForm', true);

      try {
        await this.validate();

        // Copy option, so we can modify it freely
        const entity: LightSourcePartDto = JSON.parse(JSON.stringify(this.light_source.format()));

        // Create the option
        await LightSourcePartsStore.create(entity, {
          persistent: true,
        });
      } catch (e) {
        console.error(e);
        return;
      } finally {
        this.$set(this, 'isLoadingForm', false);
      }

      this.$router.push('/parts/light-sources');
    },

    async onWizardStepChange(step: number, oldStep: number) {
      // Next step
      if (step > oldStep) {
        try {
          await this.validate(oldStep);
        } catch (e) {
          console.error(e);
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          (this.$refs.wizard as any).setStep(oldStep);
        }
      }
    },

    async validate(step?: number) {
      const validationArray: Array<Validation> = [];

      // Add validators based by step
      if (step === undefined || step === 0) {
        validationArray.push((this.$refs.informationForm as Vue).$v);
      }

      await ValidatorUtil.validateArray(
        validationArray.filter((row) => row !== undefined, []),
        {
          reset: true,
          pending_delay: 50,
        },
      );
    },
  },
});
